import { Suspense, useEffect, useState } from "react"
import { Link } from "react-router-dom-7"

import { useUserInfo } from "~/domain/user-session"
import { ErrorBoundary, MaterialIcon, PopupHint } from "~/shared/ui"
import { ErrorMessageFallback } from "~/shared/ui/components/errors/ErrorMessageFallback"
import { iconStyle } from "~/templates/main/MainUserbar/style"
import { useMediaQuery } from "react-responsive"
import { breakPoints } from "~/shared/ui/constants"


export function BugreportButton() {
	const userInfo = useUserInfo()
	const [link, setLink] = useState("")
	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	useEffect(() => {
		if (!userInfo) return

		setLink("/bugreport/user")

	}, [userInfo])

	if (!userInfo) return null

	return (
		<PopupHint text="Сообщения об ошибках" position="bottom">
			<div className="relative">
				<Link to={link}>
					<MaterialIcon
						style={{
							verticalAlign: "-0.35rem",
							fontSize: isSmallDevice ? "1.6rem" : "2.2rem", ...iconStyle
						}}
						name="bug_report"
					/>
				</Link>
				<ErrorBoundary fallback={<ErrorMessageFallback />}>
					<Suspense>
						{/*<ReportCount />*/}
					</Suspense>
				</ErrorBoundary>
			</div>
		</PopupHint>
	)
}